// Utility functions for masking sensitive data

export const maskPhoneNumber = (phoneNumber) => {
  if (!phoneNumber) return '';
  const phone = phoneNumber.toString();
  if (phone.length < 4) return phone;
  return '*'.repeat(phone.length - 4) + phone.slice(-4);
};

export const maskAadhaarNumber = (aadhaarNumber) => {
  if (!aadhaarNumber) return '';
  const aadhaar = aadhaarNumber.toString();
  if (aadhaar.length < 4) return aadhaar;
  return '*'.repeat(aadhaar.length - 4) + aadhaar.slice(-4);
};

export const formatMaskedInput = (value, type) => {
  if (!value) return '';
  
  if (type === 'phone') {
    return maskPhoneNumber(value);
  } else if (type === 'aadhaar') {
    return maskAadhaarNumber(value);
  }
  
  return value;
};